var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_72",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74b1ee",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Exclusion_72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_72-2",
    "data-name": "Exclusion 72",
    d: "M11,22A11,11,0,0,1,3.222,3.222,11,11,0,0,1,18.779,18.779,10.929,10.929,0,0,1,11,22ZM6.775,5.276h0V6.866a4.736,4.736,0,0,0,1.97,3.41l.006.005c.444.408.864.794.864,1.061S9.191,12,8.744,12.41a4.748,4.748,0,0,0-1.97,3.412v1.589a.514.514,0,0,0,.512.463h6.886a.509.509,0,0,0,.509-.463l0-1.589a4.743,4.743,0,0,0-1.968-3.41l-.008-.007c-.444-.409-.864-.8-.864-1.062s.422-.656.869-1.067a4.742,4.742,0,0,0,1.97-3.411V5.276a.514.514,0,0,0-.512-.464H7.286a.509.509,0,0,0-.509.464Zm7.391,11.576H7.293v-1.03a4.271,4.271,0,0,1,1.8-3.031c.579-.532,1.036-.952,1.036-1.447S9.674,10.428,9.1,9.9a4.271,4.271,0,0,1-1.8-3.03V5.836h6.873v1.03a4.271,4.271,0,0,1-1.8,3.031c-.579.532-1.036.952-1.036,1.446s.457.917,1.036,1.447a4.271,4.271,0,0,1,1.8,3.031v1.029ZM10.73,13.041h0L8.223,14.434a2.355,2.355,0,0,0-.487,1.387v.331h5.987v-.331a2.355,2.355,0,0,0-.487-1.387L10.73,13.041ZM8.142,8.193a7.425,7.425,0,0,0,1.4,1.377,4.388,4.388,0,0,1,1.189,1.245A4.359,4.359,0,0,1,11.918,9.57a7.4,7.4,0,0,0,1.4-1.377Z",
    fill: "#ff8d73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerRed);
export default __webpack_public_path__ + "static/media/timer-red.7a8e169cb086abfd8a6274f7918e5f67.svg";
export { ForwardRef as ReactComponent };